import React, { FormEvent, useCallback, useState } from 'react';
import styled from '@emotion/styled';
import MuiSearch from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import { i18n_search } from '@yi/i18n/phrases/i18n_search';

import { getUrlFromSearchState } from '~/src/common/algolia/utils';
import { navigate } from '~/src/common/utilities';
import { useLocale } from '~/src/components/LocaleProvider';
import { SearchBarInput as BaseSearchBarInput } from '~/src/components/SearchInput';

const SearchBarInput = styled(BaseSearchBarInput)`
  font-size: 16px;
  input {
    padding: 8px 14px;
  }
`;

const Container = styled.div`
  margin: 0 24px 16px 24px;
`;

const SearchButton = styled.button`
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
`;
export const SiteWideSearchInput: React.FC<{ className?: string }> = props => {
  const { locale } = useLocale();
  const [query, setQuery] = useState('');

  const onSubmit = useCallback(
    (e: FormEvent) => {
      e.preventDefault();

      const siteWideSearchUrl = getUrlFromSearchState('/search/', { query });

      navigate(siteWideSearchUrl);
    },
    [query],
  );

  return (
    <Container {...props}>
      <form onSubmit={onSubmit}>
        <SearchBarInput
          value={query}
          onChange={({ target: { value } }) => {
            setQuery(value);
          }}
          onSubmit={onSubmit}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchButton onClick={onSubmit}>
                  <MuiSearch />
                </SearchButton>
              </InputAdornment>
            ),
            placeholder: i18n_search(locale),
          }}
          inputProps={{ 'aria-label': 'Search input' }}
          id="SearchBox"
          type="text"
          variant="outlined"
        />
      </form>
    </Container>
  );
};
